module.exports = __webpack_public_path__ + "static/client_11_after-40c76bc185bc1e887c0533dd84a808e8.jpg";